import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import FileGalleryModal from '../FileGalleryModal'
import { Route } from 'react-router-dom'

class FileGallerySlateButtonContainer extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isModalActive: false,
      searchValue: ''
    }

    if (props.getClick) {
      props.getClick(this.onClick)
    }
  }

  onClick = e => {
    this.changeModalState(true)
  }

  changeModalState = bool => {
    if (bool) {
      this.props.history.push(this.props.match.url + '/files/1')
    } else {
      // route back to base url
      this.props.history.push(this.props.match.url)
      this.setState({
        searchValue: ''
      })
    }
    this.setState({
      isModalActive: bool
    })
  }

  onSelect = (e, data) => {
    this.props.onSelect(e, data)
  }

  toggle = () => {
    this.changeModalState(!this.state.isModalActive)
  }

  onSearchChange = value => {
    this.setState({ searchValue: value })
  }

  render () {
    let wrapperStyle = {display: 'inline-block'}
    let style = {}
    if (this.props.hide) {
      wrapperStyle = {display: 'none'}
      style = {display: 'none'}
    }

    return <div style={wrapperStyle}>
      <Route
        path={this.props.match.url + '/files/:paginationPage'}
        render={props =>
          <FileGalleryModal
            match={props.match}
            history={props.history}
            onSelect={this.onSelect}
            isOpen={this.state.isModalActive}
            filters={this.props.filters}
            searchValue={this.state.searchValue}
            onSearchChange={this.onSearchChange}
            toggle={this.toggle} />
        }
      />
      <Button style={style} onClick={this.onClick} >Image Gallery</Button>
    </div>
  }
}

FileGallerySlateButtonContainer.propTypes = {
  hide: PropTypes.bool,
  match: PropTypes.object.isRequired,
  filters: PropTypes.object,
  history: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  getClick: PropTypes.func
}

export default FileGallerySlateButtonContainer



// WEBPACK FOOTER //
// ./src/components/FileGallerySlateButton/FileGallerySlateButtonContainer.js